export const colors = {
  backgroundColor: '#1C1C1C',
  dotsRed: '#FF0050',
  dotsRed50: '#FF005080',
  dotsRed100: '#FFD5E0',
  gray100: '#C7C7C8',
  gray200: '#646464',
};
